import { AuthService } from 'phoenix/services';
import { Card } from 'sharebase/components/cardList/cardList';
import { IMenuItem } from 'sharebase/domain/sharebase-menu';
import { MenuFactory } from 'sharebase/factories/menuFactory';
import {
	Task,
	TaskResult,
	TaskStatus
} from 'sharebase/domain';

const template = require('./tasks-cards.template');

class TasksCards implements ng.IComponentController{
	public static $inject = [
		'$state',
		'pxAuthService',
		'sbMenuFactory',
		'sbSimpleDateTimeStringFilter',
		'sbDueDateMessageFilter',
		'gettextCatalog'
	];

	constructor(
		private $state:ng.ui.IStateService,
		private pxAuthService:AuthService,
		private sbMenuFactory:MenuFactory,
		private sbSimpleDateTimeStringFilter,
		private sbDueDateMessageFilter,
		private gettextCatalog:ng.gettext.gettextCatalog
	) {
	}

	public config = {
		hasAvatar: true,
		maxHeight: 394,
		virtualize: false
	}

	public transform = (task:Task, actions:IMenuItem[]) => {
		let card:Card<Task> = {
			icon: 'check',
			header: {
				text: task.creatorId === this.pxAuthService.userId ? 
					this.gettextCatalog.getString('Assigned to: {{assignee}}', { assignee: task.assigneeName }) :
					this.gettextCatalog.getString('Assigned by: {{taskCreator}}', { taskCreator: task.creatorName }),
				subtext: this.getStatus(task)
			},
			body: { 
				text: task.targetObjectName,
				subtext: task.instructions
			},
			source: task,
			isDisabled: task.isDocumentShareExpired,
			menu: this.sbMenuFactory.create(),
			trigger: () => card.isDisabled || this.$state.go('content.myFiles.document', {'docID': task.targetId })
		}
		
		actions.forEach(action => card.menu.addItem(angular.copy(action)));
		card.menu.getActiveItems(card.source);

		return card;
	}

	private getStatus(task:Task) {
		if (task.status === TaskStatus.Open) {
			// passes strings through gettextCatalog first
			return this.sbDueDateMessageFilter(task.daysUntilDue);
		}
		return this.getResolvedTaskStatus(task);
	}

	private getResolvedTaskStatus(task:Task) {
		let statusString = '';
		if (!task.dateEnded) {
			return statusString;
		}

		let dateEndedStr = this.sbSimpleDateTimeStringFilter(task.dateEnded);
		let endedToday = isDateToday(task.dateEnded);
		// alternate case needed for proper Spanish translation
		let isOneOClock = task.dateEnded.getHours() % 12 === 1;

		switch(task.status) {
			case TaskStatus.Completed:
				if (task.result === TaskResult.Positive) {
					if (endedToday) {
						statusString = isOneOClock ?
							this.gettextCatalog.getString('Approved at {{ oneOClockTime }}', {oneOClockTime: dateEndedStr}) :
							this.gettextCatalog.getString('Approved at {{ time }}', {time: dateEndedStr});
					} else {
						statusString = this.gettextCatalog.getString('Approved on {{date}}', {date: dateEndedStr});
					}
				} else {
					if (endedToday) {
						statusString = isOneOClock ?
							this.gettextCatalog.getString('Denied at {{ oneOClockTime }}', {oneOClockTime: dateEndedStr}) :
							this.gettextCatalog.getString('Denied at {{ time }}', {time: dateEndedStr});
					} else {
						statusString = this.gettextCatalog.getString('Denied on {{date}}', {date: dateEndedStr});
					}
				}
				break;
			case TaskStatus.Cancelled:
				if (endedToday) {
					statusString = isOneOClock ? 
						this.gettextCatalog.getString('Cancelled at {{oneOClockTime}}', {oneOClockTime: dateEndedStr}) :
						this.gettextCatalog.getString('Cancelled at {{time}}', {time: dateEndedStr});

				} else {
					statusString = this.gettextCatalog.getString('Cancelled on {{date}}', {date: dateEndedStr});
				}
				break;
			case TaskStatus.Expired:
				if (endedToday) {
					statusString = isOneOClock ? 
						this.gettextCatalog.getString('Expired at {{oneOClockTime}}', {oneOClockTime: dateEndedStr}) :
						this.gettextCatalog.getString('Expired at {{time}}', {time: dateEndedStr});

				} else {
					statusString = this.gettextCatalog.getString('Expired on {{date}}', {date: dateEndedStr});
				}
				break;
		}

		return statusString;

		function isDateToday(date:Date) {
			let today = new Date();	
			return today.getDate() === date.getDate() &&
				today.getMonth() === date.getMonth() &&
				today.getFullYear() === date.getFullYear()
		}
	}
}

export const TasksCardsComponent:ng.IComponentOptions = {
	template: template,
	controller: TasksCards,
	controllerAs: 'vm',
	bindings: {
		source: '<',
		actions: '<',
		emptyState: '<'
	}
}



// WEBPACK FOOTER //
// ./src/sharebase-app/components/tasks-cards/tasks-cards.ts